module.exports = __webpack_public_path__ + "img/Loaneo-Logo-01.b4a2788a.png";